import SwapVertIcon from "@mui/icons-material/SwapVert";
import { IconButton } from "@mui/material";
import { Form } from "react-bootstrap";
import { useGeneralAppStore } from "../../../../store/generalAppStore";
import { useFilterActas } from "../../../../store/filterActasStore";
import ModalRangoFecha from "../../../../views/modals/ModalRangoFecha";
import { format, parse } from "date-fns";

const HeaderColumn = ({ setFiltersField, setOrder, setOrderField, field, typeInput, place, reportes, label, color }) => {


    //TODO ESTADOS GLOBALES
    //TODO  ------------------------------------------------------------------------------------------
    const { loads, handlerModal, modals } = useGeneralAppStore();

    //& KEYS
    //& -----------------------------------------------------------------------------------------
    const loadKeys = [
        "asignar_notificador",
        "acta_detalle",
        "desasignar_notificador",
        "marcar_impresa",
        "notificadores",
        // "actas",
        // "get_actas"
    ];



    const { setFilterFields, setOrderBy, filterFields } = useFilterActas();

    return (
        <>
            <div className={`${label && "d-flex flex-column align-items-center gap-1 "}`}>

                {
                    label &&
                    <div className="d-flex align-items-center">
                        <label style={{ color: color ?? "#111" }}>{label}</label>
                        <IconButton
                            className="p-0"
                            disabled={loadKeys.some(key => loads.includes(key))}
                            onClick={() => {
                                setOrder((prevState) => {

                                    if (prevState == "asc") {
                                        prevState = "des";
                                    } else {
                                        prevState = "asc"
                                    }
                                    return prevState;
                                });
                                setOrderField(field)
                                setOrderBy(field)

                            }}
                        >
                            <SwapVertIcon sx={{ width: "30px", color: color ?? "#111" }} />
                        </IconButton>
                    </div>
                }
                <div className={`d-flex  align-items-center `}>
                    {
                        typeInput == 'select' &&
                        <Form.Select
                            disabled={loadKeys.some(key => loads.includes(key))}
                            className="col "
                            name={field} id={field}
                            onChange={(e) => {
                                setFilterFields(e.target.name, e.target.value);
                                setFiltersField((prevState) => ({
                                    ...prevState,
                                    [e.target.name]: e.target.value,
                                }));
                            }}
                        >
                            {
                                field == 'zona' &&
                                <>
                                    <option value="">Zona</option>
                                    <option value="local">Local</option>
                                    <option value="extraña_juridiccion ">Extaña juridiccion</option>
                                </>
                            }
                            {
                                field == 'tipo' &&
                                <>
                                    <option value="">Tipo</option>
                                    <option value="Semaforo Senda">Semaforo Senda</option>
                                    <option value="Semaforo Giro">Semaforo Giro</option>
                                    <option value="Semaforo Luz Roja">Semaforo Luz Roja</option>
                                </>
                            }
                            {
                                (field == 'estado_id') &&
                                <>
                                    {reportes ?
                                        <>
                                            <option value="">Estado</option>
                                            <option value="8">EN REPARTO</option>
                                            <option value="4">NOTIFICADO</option>
                                            <option value="11">ABONADAS</option>
                                            <option value="15">TRIBUNALES</option>
                                            <option value="13">DESCARGO</option>
                                            <option value="9">SIN ENTREGAR</option>
                                        </>
                                        :
                                        <>
                                            <option value="">Estado</option>
                                            <option value="1">SIN ACTA</option>
                                            <option value="3">CON ACTA A CHEQUEAR</option>
                                            <option value="7">DOMICILIO INCOMPLETO</option>
                                            <option value="9">SIN ENTREGAR</option>
                                            <option value="16">SIN BENEFICIO PAGO VOLUNTARIO</option>
                                        </>
                                    }
                                </>

                            }
                            {
                                field == 'motivo' &&
                                <>
                                    <option value="">Motivo</option>
                                    <option value="Duplicado">Duplicado</option>
                                    <option value="Lista blanca">Lista blanca</option>
                                    <option value="No es infracción">No es infracción</option>
                                    <option value="Vehículo oficial">Vehículo oficial</option>
                                    <option value="Error de sistema">Error del sistema</option>
                                </>
                            }
                        </Form.Select>
                    }
                    {/* {console.log(filterFields)}
                    {console.log(field)}
                    {console.log(filterFields[field])} */}
                    
                    {
                        (typeInput == 'text' || typeInput == 'number') &&
                        <Form.Control
                            disabled={loadKeys.some(key => loads.includes(key))}
                            type={typeInput}
                            name={field}
                            value={filterFields[field] ?? ""}
                            className="col "
                            placeholder={place}
                            onChange={(e) => {
                                setFilterFields(e.target.name, e.target.value);
                                setFiltersField((prevState) => ({
                                    ...prevState,
                                    [e.target.name]: e.target.value,
                                }));
                            }}
                        />
                    }
                    {
                        (typeInput == 'date') &&
                        <>
                            <button
                                disabled={loadKeys.some(key => loads.includes(key))}
                                onClick={() => handlerModal({ modal: true, modalName: "rango_fecha" })} style={{ cursor: "pointer", paddingTop: "6px", paddingBottom: "6px", height: "38px", width: "100%" }} className="border border-1 border-secondary-subtle rounded mx-auto  px-3">
                                {/* { (!filterFields.fecha_desde && !filterFields.fecha_hasta ) && "Filtrar fechas"} */}
                                {!filterFields?.fecha_desde && !filterFields?.fecha_hasta && "Filtrar fechas"}
                                {filterFields?.fecha_desde && !filterFields?.fecha_hasta && `Desde ${format(parse(filterFields?.fecha_desde, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy')}`}
                                {!filterFields?.fecha_desde && filterFields?.fecha_hasta && `Hasta ${format(parse(filterFields?.fecha_hasta, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy')}`}
                                {filterFields?.fecha_desde && filterFields?.fecha_hasta && `${format(parse(filterFields?.fecha_desde, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy')} - ${format(parse(filterFields?.fecha_hasta, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy')}`}
                            </button>

                        </>
                    }



                    {
                        !label &&

                        <IconButton
                            disabled={loadKeys.some(key => loads.includes(key))}
                            onClick={() => {
                                setOrder((prevState) => {

                                    if (prevState == "asc") {
                                        prevState = "des";
                                    } else {
                                        prevState = "asc"
                                    }
                                    return prevState;
                                });
                                setOrderField(field)
                            }}
                        >
                            <SwapVertIcon sx={{ width: "30px", color: color ?? "#111" }} />
                        </IconButton>
                    }
                </div>
            </div>
        </>
    );
}
export default HeaderColumn;